module.exports = __webpack_public_path__ + "img/info.00ce7bcf.svg";